import {
  PaletteColor,
  PaletteOptions,
  ThemeOptions,
  alpha,
  createTheme,
} from "@mui/material/styles";
// import type {} from "@mui/x-date-pickers/themeAugmentation";
import type {} from "@mui/x-data-grid/themeAugmentation";
// import "@mui/x-date-pickers/themeAugmentation";
import "@mui/x-data-grid/themeAugmentation";
// import type {} from '@mui/lab/themeAugmentation';
// import '@mui/lab/themeAugmentation';
const primaryMain = "#00E852";

const shape = {
  borderRadius: 10,
};
const palette: PaletteOptions = {
  mode: "dark",
  primary: {
    main: primaryMain,
    light: alpha(primaryMain, 0.5),
    dark: alpha(primaryMain, 0.9),
  },
  secondary: {
    main: "#f50057",
  },
  background: {
    default: "#000000",
    paper: "#000",
  },
  divider: "#626262",
  text: {
    primary: "#CFCFCF",
    secondary: "#fff",
  },
};
const themeOptions: ThemeOptions = {
  palette: palette,
  direction: "ltr",
  shape: shape,
  typography: {
    fontFamily: "Circular Std",
  },
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: shape.borderRadius,
          "&:hover": {
            backgroundColor: "rgb(0, 162, 57)",
          },
          "&.Mui-selected": {
            "& .MuiTypography-root": {
              color: "white",
            },
            backgroundColor: (palette.primary as PaletteColor).main,
            "&:hover": {
              backgroundColor: (palette.primary as PaletteColor).main,
            },
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          margin: 0,
          "& .MuiTypography-root": {
            color: "#636363",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#2B2B2B",
          "& input": {
            padding: "12px 16px",
          },
          "& fieldset": {
            border: "none",
          },
          "& svg": {
            color: (palette.primary as PaletteColor).main,
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&[data-shrink="false"]': {
            transform: "translate(16px, 12px) scale(1) !important",
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body1: {
          color: "#CFCFCF",
        },
        subtitle1: {
          color: "#CFCFCF",
        },
        subtitle2: {
          color: "#636363",
        },
      },
    },

    MuiButton: {
      variants: [
        {
          props: { variant: "contained" },
          style: {
            color: "white",
            "&.MuiLoadingButton-loading svg": {
              color: (palette.primary as PaletteColor).main,
            },
          },
        },
      ],
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          backgroundColor: "#242424",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: "#242424",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          backgroundColor: "#242424",
          "& .MuiDataGrid-columnHeader:focus, .MuiDataGrid-cell:focus, .MuiDataGrid-columnHeader:focus-within, .MuiDataGrid-cell:focus-within":
            {
              outline: "none",
            },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "8px 24px 24px",
        },
      },
    },
  },
};

export const theme = createTheme(themeOptions);
